import React, { useState, useEffect } from 'react'
import { makeStyles, Grid, Typography, Button } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { withRouter } from 'react-router'
import RegulationCard from '../../RegulationCard'
import { useStateValue } from 'context/store'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import clsx from 'clsx'

const regulationsStyles = makeStyles(theme => ({
   regulationsContainer: {
      width: 310,
      maxHeight: 500,
      display: 'flex',
      flexDirection: 'column'
   },
   header: {
      margin: theme.spacing(1, 0),
      display: 'flex'
   },
   title: {
      fontWeight: 'bold',
      margin: 'auto'
   },
   backButton: {
      cursor: 'pointer'
   },
   body: {
      flex: '1 1 auto',
      overflowY: 'auto',
      overflowX: 'hidden'
   },
   footer: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: theme.spacing(2)
   },
   fullButton: {
      width: '100%'
   },
   halfButton: {
      width: '48%'
   },
   formCleanButton: {
      color: '#3264DC',
      border: '1px solid #3264DC',
      fontWeight: 'bold'
   }
}))

export function sortRegulationsSummaryByDate(left, right) {
   return moment(
      `${right.createdDate} ${right.hour}`,
      'DD-MM-YYYY hh:mm:ss'
   ).diff(moment(`${left.createdDate} ${left.hour}`, 'DD-MM-YYYY hh:mm:ss'))
}

function RegulationsSummary({ setCurrentView, handleClose, history }) {
   const classes = regulationsStyles()

   const [regulationsByDate, setRegulationsByDate] = useState([])

   const [{ regulationsSummary = [], sessionUser = {} }] = useStateValue()
   const {
      authorizedOptions: { addRegulatons }
   } = sessionUser

   useEffect(() => {
      if (regulationsSummary.length) {
         const arrangedRegulations = cloneDeep(
            regulationsSummary.sort(sortRegulationsSummaryByDate)
         )
         setRegulationsByDate(arrangedRegulations)
      }
   }, [regulationsSummary])

   function goToHelpView() {
      setCurrentView('helpView')
   }

   function goToAllRegulations() {
      handleClose()
      history.push('/dashboard/regulations')
   }

   function goToAddNewRegulation() {
      setCurrentView('addNewRegulationView')
   }

   return (
      <Grid className={classes.regulationsContainer}>
         <Grid className={classes.header}>
            <ArrowBackIcon
               className={classes.backButton}
               onClick={goToHelpView}
            />
            <Typography className={classes.title}>
               Circulares y Normativas
            </Typography>
         </Grid>
         <Grid className={classes.body}>
            {regulationsByDate.map((regulation, index) => (
               <RegulationCard
                  key={index}
                  regulation={regulation}
                  isCollapsable={true}
               />
            ))}
         </Grid>
         <Grid className={classes.footer}>
            <Button
               className={clsx(classes.formCleanButton, {
                  [classes.fullButton]: !addRegulatons,
                  [classes.halfButton]: addRegulatons
               })}
               onClick={goToAllRegulations}
            >
               VER HISTORIAL
            </Button>
            {addRegulatons && (
               <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.halfButton}
                  onClick={goToAddNewRegulation}
               >
                  AGREGAR NUEVA
               </Button>
            )}
         </Grid>
      </Grid>
   )
}

export default withRouter(RegulationsSummary)
